export var TITLE = 'Yi';
export var TEXT_MULTIPLE = 0.8;
export var SPACE_MULTIPLE = 0.2;
export var COLOR_PRIMARY = '#003425';